export default __webpack_public_path__ + "static/media/longchamp26.28c6353c.jpg";